(() => {
    const servicesContainer = document.getElementsByClassName('columns--services');

    if (servicesContainer.length) {
        servicesContainer[servicesContainer.length - 1].classList.add('columns--services-last');
    }
})();